
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/awsfargate/thanks",
      function () {
        return require("private-next-pages/services/awsfargate/thanks.tsx");
      }
    ]);
  